/* ========================================================================
* WooCommerce specific scripts. Use of main.js template
* ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var SageWoo = {
        // All pages
        'common': {
            init: function() {
                // Update WooCommerce Product Add-on - Javascript Range-Slider

                function updateRangeValRenderer(value, name) {
                    var rangeValRenderer = document.getElementById(name);
                    rangeValRenderer.textContent = value;
                }
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Product archive page
        'post_type_archive_product': {
            init: function() {
                // JavaScript to be fired on the shop page
                // JavaScript to be fired on the shop page
                $('.product-categories-slider').slick({
                    dots: false,
                    arrows: true,
                    prevArrow: '<i class="icon-left-open arrow-prev" aria-hidden="true"></i>',
                    nextArrow: '<i class="icon-right-open arrow-next" aria-hidden="true"></i>',
                    infinite: false,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    responsive: [
                        {
                          breakpoint: 600,
                          settings: {
                            slidesToShow: 3,
                          }
                        },
                        {
                          breakpoint: 480,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                          }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                        ]
                });
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // WooCommerce YITH wishlist page
        'woocommerce_wishlist': {
            init: function() {
                // Product table data-titles for yith wishlist responsive table
                var productRemove = table_translations.yith_wl_th_product_remove;
                var productName = table_translations.yith_wl_th_product_name;
                var productPrice = table_translations.yith_wl_th_product_price;
                var productStock = table_translations.yith_wl_th_product_stock;

            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
                $('a.remove_from_wishlist').attr('aria-label', productRemove);
                $('td.product-name').attr('data-title', productName);
                $('td.product-price').attr('data-title', productPrice);
                $('td.product-stock-status').attr('data-title', productStock);
            }
        },
        // WooCommerce checkout page
        'woocommerce_checkout': {
            init: function() {

            },
            finalize: function() {

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = SageWoo;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
